import ApplicationAdapter from './application';

/**
 *
 * @memberof adapters
 */
class InviteAdapter extends ApplicationAdapter {
  async getInviteByCode(inviteCode: string) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('invites', inviteCode);
    // @ts-expect-error stop using adapters
    return await this.ajax(url);
  }
}

export default InviteAdapter;
